export default __webpack_public_path__ + "static/media/AMBL.8bfa6bd8.png";